import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './List.scss';

import ListItem from './ListItem';

const selector = state => {
    const { language } = state;
    return {
        t: language.translator
    }
};

const List = props => {
    const { t } = useSelector(selector);
    const {
        roundTopCorners,
        scroll,
        items,
        page,
        itemsPerPage,
        pageCount,
        itemsCount,
        getItemsMethod,
        selectItemMethod,
        onSelectModalName,
        columns,
        columnsNames,
        columnsWidths,
        filter,
        avatarColumn,
        avatarUrl,
        measurementTimeColumn,
        booleanColumn,
        invertedBooleanColumn,
        userId,
        search,
        lat,
        lon,
        referenceColumn,
        referenceField,
        referenceData,
        selected,
        picker,
        deleteMethod,
        deleteColumn,
        rainSensorColumn,
        wetLeafSensorColumn,
        alarmLowColumn,
        warningLowColumn,
        alarmHighColumn,
        warningHighColumn,
        checkboxColumn,
        handleSelectSensors,
        selectedSensors,
        editColumn,
        editMethod,
        editAlertColumn,
        columnColors,
        sensorType,
        inSensorColumn,
        outSensorColumn,
        dateColumn,
        virtualStationColumn,
        rimOnly,
        selectableColumn,
        isItemSelected,
        onItemSelectionChange
    } = props;
    const dispatch = useDispatch();

    const normalizedPageCount = Math.max(pageCount || 0, 0);
    const displayedPage = normalizedPageCount === 0
        ? 0
        : Math.min(Math.max(page || 1, 1), normalizedPageCount);

    const [pageInputValue, setPageInputValue] = useState(
        displayedPage ? displayedPage.toString() : ''
    );

    useEffect(() => {
        setPageInputValue(displayedPage ? displayedPage.toString() : '');
    }, [displayedPage]);

    const loadPage = targetPage => {
        if (normalizedPageCount === 0) {
            return;
        }

        const clampedPage = Math.min(Math.max(targetPage, 1), normalizedPageCount);

        if (clampedPage !== page) {
            dispatch(getItemsMethod(clampedPage, itemsPerPage, filter, userId, search, lat, lon, sensorType, rimOnly));
        }
    };

    const handleFirstButtonClick = () => {
        loadPage(1);
    };

    const handlePreviousButtonClick = () => {
        loadPage(displayedPage - 1);
    };

    const handleNextButtonClick = () => {
        loadPage(displayedPage + 1);
    };

    const handleLastButtonClick = () => {
        loadPage(normalizedPageCount);
    };

    const handlePageInputChange = event => {
        const { value } = event.target;

        if (value === '' || /^\d+$/.test(value)) {
            setPageInputValue(value);
        }
    };

    const handlePageInputSubmit = () => {
        if (normalizedPageCount === 0) {
            setPageInputValue('');
            return;
        }

        if (pageInputValue === '') {
            setPageInputValue(displayedPage.toString());
            return;
        }

        const parsedPage = Number(pageInputValue);

        if (!Number.isInteger(parsedPage)) {
            setPageInputValue(displayedPage.toString());
            return;
        }

        loadPage(parsedPage);
    };

    const columnWidth = !columnsWidths
        ? (100 / columnsNames.length).toString() + '%'
        : null;

    return (
        <ul className={roundTopCorners ? 'list list--roundTop' : 'list'}>

            <li className='listHeader'>
                {(!!checkboxColumn) && (
                    <div className='listHeaderCell checkboxHeader'/>
                )}
                {columnsNames.map((columnName, index) => (
                    <div className='listHeaderCell' key={index} style={{width: !columnWidth ? columnsWidths[index] : columnWidth, color: columnColors ? columnColors[index] : null}}>
                        {columnName ? t.gettext(columnName) : ''}
                    </div>
                ))}
            </li>

            <div className={scroll ? 'listItems listItems--scroll' : 'listItems'}>
                {items.map((item, index) => (
                    <ListItem
                        key={index}
                        item={item}
                        index={index}
                        page={page}
                        columns={columns}
                        columnsWidths={columnsWidths}
                        columnWidth={columnWidth}
                        selectItemMethod={selectItemMethod}
                        onSelectModalName={onSelectModalName}
                        avatarColumn={avatarColumn}
                        avatarUrl={avatarUrl}
                        measurementTimeColumn={measurementTimeColumn}
                        booleanColumn={booleanColumn}
                        invertedBooleanColumn={invertedBooleanColumn}
                        referenceColumn={referenceColumn}
                        referenceField={referenceField}
                        referenceData={referenceData}
                        selected={selected}
                        picker={picker}
                        deleteMethod={deleteMethod}
                        deleteColumn={deleteColumn}
                        rainSensorColumn={rainSensorColumn}
                        wetLeafSensorColumn={wetLeafSensorColumn}
                        alarmLowColumn={alarmLowColumn}
                        warningLowColumn={warningLowColumn}
                        alarmHighColumn={alarmHighColumn}
                        warningHighColumn={warningHighColumn}
                        checkboxColumn={checkboxColumn}
                        handleSelectSensors={handleSelectSensors}
                        selectedSensors={selectedSensors}
                        editColumn={editColumn}
                        editMethod={editMethod}
                        editAlertColumn={editAlertColumn}
                        inSensorColumn={inSensorColumn}
                        outSensorColumn={outSensorColumn}
                        dateColumn={dateColumn}
                        virtualStationColumn={virtualStationColumn}
                        selectableColumn={selectableColumn}
                        isItemSelected={isItemSelected}
                        onItemSelectionChange={onItemSelectionChange}
                    />
                ))}
            </div>

            {!scroll &&
                <li className='listPaginationRow'>
                    {/*<div className='listPaginationCounter'>*/}
                    {/*    {*/}
                    {/*        t.gettext('Showing') + ' '*/}
                    {/*        + items.length + ' '*/}
                    {/*        + t.gettext('out of') + ' '*/}
                    {/*        + itemsCount + ' '*/}
                    {/*        + t.gettext('entries')*/}
                    {/*    }*/}
                    {/*</div>*/}
                    {/*<div className='listPaginationButtons'>*/}
                    {/*    <div*/}
                    {/*        className={page > 1*/}
                    {/*            ? 'listPaginationButton'*/}
                    {/*            : 'listPaginationButton listPaginationButton--disabled'*/}
                    {/*        }*/}
                    {/*        onClick={handlePreviousButtonClick}*/}
                    {/*    >*/}
                    {/*        {t.gettext('Previous')}*/}
                    {/*    </div>*/}
                    {/*    {pages.map(pageNumber =>*/}
                    {/*        <div*/}
                    {/*            className={pageNumber === page*/}
                    {/*                ? 'listPaginationButton listPaginationButton--active'*/}
                    {/*                : 'listPaginationButton'*/}
                    {/*            }*/}
                    {/*            //  dispatch(getItemsMethod(page + 1, itemsPerPage, filter, userId, search, lat, lon, sensorType));*/}
                    {/*            onClick={() => dispatch(getItemsMethod(pageNumber, itemsPerPage, filter, userId, search,  lat, lon, sensorType))}*/}
                    {/*            key={pageNumber}*/}
                    {/*        >*/}
                    {/*            {pageNumber}*/}
                    {/*        </div>*/}
                    {/*    )}*/}
                    {/*    <div*/}
                    {/*        className={page < pageCount*/}
                    {/*            ? 'listPaginationButton'*/}
                    {/*            : 'listPaginationButton listPaginationButton--disabled'*/}
                    {/*        }*/}
                    {/*        onClick={handleNextButtonClick}*/}
                    {/*    >*/}
                    {/*        {t.gettext('Next')}*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                    <div className="listPaginationButtons">
                        <button
                            type='button'
                            className={displayedPage > 1
                                ? 'listPaginationButton listPaginationButton--icon'
                                : 'listPaginationButton listPaginationButton--icon listPaginationButton--disabled'
                            }
                            onClick={handleFirstButtonClick}
                            disabled={displayedPage <= 1}
                            title={t.gettext('First')}
                            aria-label={t.gettext('First')}
                        >
                            |&lt;
                        </button>
                        <button
                            type='button'
                            className={displayedPage > 1
                                ? 'listPaginationButton listPaginationButton--icon'
                                : 'listPaginationButton listPaginationButton--icon listPaginationButton--disabled'
                            }
                            onClick={handlePreviousButtonClick}
                            disabled={displayedPage <= 1}
                            title={t.gettext('Previous')}
                            aria-label={t.gettext('Previous')}
                        >
                            &lt;
                        </button>
                        <div className="listPaginationSummary">
                            {`${displayedPage} of ${normalizedPageCount}`}
                        </div>
                        <div className='listPaginationInputWrapper'>
                            <input
                                className='listPaginationInput'
                                type='number'
                                min='1'
                                max={normalizedPageCount}
                                value={pageInputValue}
                                onChange={handlePageInputChange}
                                onBlur={handlePageInputSubmit}
                                onKeyDown={event => {
                                    if (event.key === 'Enter') {
                                        handlePageInputSubmit();
                                        event.currentTarget.blur();
                                    }
                                }}
                                aria-label={t.gettext('Go to page')}
                                disabled={normalizedPageCount === 0}
                            />
                        </div>
                        <button
                            type='button'
                            className={displayedPage < normalizedPageCount
                                ? 'listPaginationButton listPaginationButton--icon'
                                : 'listPaginationButton listPaginationButton--icon listPaginationButton--disabled'
                            }
                            onClick={handleNextButtonClick}
                            disabled={displayedPage >= normalizedPageCount}
                            title={t.gettext('Next')}
                            aria-label={t.gettext('Next')}
                        >
                            &gt;
                        </button>
                        <button
                            type='button'
                            className={displayedPage < normalizedPageCount
                                ? 'listPaginationButton listPaginationButton--icon'
                                : 'listPaginationButton listPaginationButton--icon listPaginationButton--disabled'
                            }
                            onClick={handleLastButtonClick}
                            disabled={displayedPage >= normalizedPageCount}
                            title={t.gettext('Last')}
                            aria-label={t.gettext('Last')}
                        >
                            &gt;|
                        </button>
                    </div>
                </li>
            }

        </ul>
    )
}

export default List;
